import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import LeftComponent from "../components/LeftComponent";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import "../css/invoiceScreen.css";
import { listSubAgentInvoices } from "../actions/InvoiceSubAgentActions";

export default function TaskScreen(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    
  }, [dispatch]);

  return (
    <>
      <Header pageName="Task Dashboard" />
      <LeftComponent>
        <div className="content-body">
          <div className="container-fluid">
            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Task..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/* <!-- /filter-in-mob-view --> */}

                  <div className="add-filter">
                    <div className="filter-title  filter-title-mob">
                      <h5>Filter Task </h5>
                      <button className="mob-nav-open">☰</button>
                    </div>
                    <div className="filter-body filter-body-mob custom-scroll-right pt-0">
                      <div className="sticky pt-2">
                        <h6>
                          <strong>All Task</strong>
                        </h6>

                        <p>No Of Task</p>

                        <button className="btn btn-sm btn-deep-orange">
                          Reset filters
                        </button>
                      </div>

                      <ul className="modify-filter-title">
                        <li>Month:</li>
                        <li>
                          <select className="form-control" name="university">
                            <option value="">--Select--</option>
                          </select>
                        </li>
                        <li>
                          Invoiced Raised Date <br />
                          From:
                        </li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="paymentFrom"
                          />
                        </li>
                        <li>To:</li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="paymentTo"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-lg-10">
                  <div className="row">
                    <div className="col-md-12 ">
                      <div className="home-table-search float-right d-flex">
                        <div className="input-group search-contacts" style={{paddingBottom:14}}>
                          <input
                            type="text"
                            id="searchTask"
                            className="form-control ng-pristine ng-valid ng-empty ng-touched"
                            placeholder="Search Task"
                            name="searchtxt"
                            // value={invoiceData.searchtxt}
                            // onChange={(e) => {
                            //   setInvoices(e);
                            // }}
                            // onKeyDown={(e) => {
                            //   if (e.key === "Enter") {
                            //     applySearchFilter();
                            //   }
                            // }}
                          />
                          <i
                            className="fa fa-search"
                            aria-hidden="true"
                            // onClick={applySearchFilter}
                          ></i>
                        </div>
                        <div className="right-click Create-btn">
                          {/* <a className="btn create-contact">Create Task</a> */}
                        </div>
                      </div>
                      {/* <input type="text" className="form-control sm" />
                                            <Link to="/invoice/create" target="_blank" className='a-btn'>Add Invoice</Link> */}
                    </div>
                  </div>

                  <div className="coctacts-table">
                    <div className="table-responsive custom-scroll-right-bottum">
                      <table className="table table-condensed ">
                        <thead className="t-head-th-bg">
                          <tr>
                            <th className="t-head-fixed">Task Title</th>
                            <th className="t-head-fixed">Invoice Id</th>
                            <th className="t-head-fixed">Invoice Date</th>
                            <th className="t-head-fixed">Application No</th>
                            <th className="t-head-fixed">Month</th>
                            <th className="t-head-fixed">Year</th>
                            <th className="t-head-fixed">
                              Invoice Raised Date
                            </th>
                            <th className="t-head-fixed">
                              Invoice Raised Amount
                            </th>
                            <th className="t-head-fixed">File</th>
                            <th className="t-head-fixed">Creator</th>
                          </tr>
                        </thead>
                        <tbody className="table-bordered">
                          <tr>
                            <td className="t-head-fixed">Contact</td>
                            <td className="t-head-fixed">Sub Agent</td>
                            <td className="t-head-fixed">Sub Agent P.Number</td>
                            <td className="t-head-fixed">Application No</td>
                            <td className="t-head-fixed">Month</td>
                            <td className="t-head-fixed">Year</td>
                            <td className="t-head-fixed">
                              Invoice Raised Date
                            </td>
                            <td className="t-head-fixed">
                              Invoice Raised Amount
                            </td>
                            <td className="t-head-fixed">File</td>
                            <td className="t-head-fixed">Creator</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-page-details">
                      <div className="row">
                        <div className="col-md-9">
                          <ReactPaginate
                            className="pagination justify-content-center"
                            activeClassName="activeClass"
                            breakLabel="..."
                            nextLabel="Next"
                            nextClassName="nextClass"
                            previousClassName="previousClass"
                            pageClassName="page-item"
                            //onPageChange={(e) => applyPageFilter(e)}
                            pageRangeDisplayed={5}
                            pageCount={10}
                            previousLabel="Previous"
                            renderOnZeroPageCount={null}
                            pageLinkClassName="page-link"
                          />
                        </div>
                        <div className="col-md-3 text-center">
                          <div className="page-counter">
                            <label>
                              Showing &nbsp;
                              <select name="pageSize">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>{" "}
                              of <span>1</span> records
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LeftComponent>
    </>
  );
}
